module.exports = __webpack_public_path__ + "static/img/101855.15d57e3a.png";